import Slider from './slider.vue'

/* istanbul ignore next */
Slider.install = function (Vue) {
  Vue.component(Slider.name, Slider)
}

export default Slider
